import { MDBContainer } from 'mdbreact';
import React from 'react';
import { connect } from 'react-redux';
import BasePureComponent, { BasePureComponentProps } from '../../components/Shared/BasePureComponent';
import Layout from '../../components/Shared/Layout';
import { Language } from '../../redux/store/base/language';

import Vedio from '../../components/Vedio/Vedio';
import Comment from '../../components/Comment/Comment';
import Footer from '../../components/Footer/Footer';

import Header from './Header/Header';
import Info from './Info/Info';

// Import asset
import "./Blog.scss";

class Blog extends BasePureComponent<BlogProps> {
    constructor(props: BlogProps) {
        super(props);
    }
    render() {
        return <Layout title={this.props.title}>
            <MDBContainer className="component blog" fluid>
                <Header />
                <Info />
                <Vedio />
                <Comment />
                <Footer />
            </MDBContainer>
        </Layout>
    }
}

function mapStateToProps(state) {
    return {
        lang: state.lang.dictionary as Language,
    }
}

interface BlogProps extends BasePureComponentProps {
    title: string;
}

export default connect(mapStateToProps)(Blog);